export class Permission {
  Module: string;
  Description: string;

  constructor(module: string, description: string) {
    this.Module = module;
    this.Description = description;
  }
}
